// цвет токена с прозрачностью: withAlpha(colors.background.fixed.fixedBlack, 30)
export const withAlpha = (color: string, percent: number) =>
  `color-mix(in srgb, ${color} ${percent}%, transparent)`
